import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIconContainer, StyledCenteredContainer, StyledIconCarImage, StyledImage, StyledImageContainer, TagsContainer, } from "./ImageCar.style";
import { ImageCarBorderRadius, ImageCarSizes, } from "./constants";
import { forwardRef, useState } from "react";
import ActionIcon from "../../../Molecules/Button/ActionIcon/ActionIcon";
import Circle from "../../../Molecules/Loading/Circle/Circle";
import { Contrast } from "../../../types/general.types";
import { InformativeTag } from "../../../Atoms";
import iconImageCarUrl from "./images/Icon_image_car.png";
const ImageCar = forwardRef(({ imageUrl, imageAlt = "", loading, size = ImageCarSizes.medium, borderRadius = ImageCarBorderRadius.none, hasActionIcon = false, onClickActionIcon = () => { }, onError, tag1, tag2, ...props }, ref) => {
    const [imageLoadingError, setImageLoadingError] = useState(false);
    const [imageLoadingFromBrowser, setImageLoadingFromBrowser] = useState(true);
    const imageLoading = loading || imageLoadingFromBrowser;
    const handleError = () => {
        setImageLoadingError(true);
        onError && onError();
    };
    const handleLoad = () => {
        setImageLoadingFromBrowser(false);
    };
    const renderTags = () => {
        if (tag1 || tag2) {
            return (_jsxs(TagsContainer, { hasActionIcon: hasActionIcon, size: size, children: [tag1 && (_jsx(InformativeTag, { contrast: Contrast.dark, ...tag1, children: tag1.text })), tag2 && (_jsx(InformativeTag, { contrast: Contrast.dark, ...tag2, children: tag2.text }))] }));
        }
    };
    const imageContent = () => {
        const isEmptyAndNotLoading = !imageLoading && !imageUrl;
        if (imageLoadingError || isEmptyAndNotLoading) {
            return (_jsx(StyledIconCarImage, { src: iconImageCarUrl, alt: "Icone Carro", size: size }));
        }
        return (_jsxs("div", { ref: ref, children: [imageLoading && (_jsx(StyledCenteredContainer, { children: _jsx(Circle, { active: imageLoading, animation: {
                            duration: 0.2
                        } }) })), _jsx(StyledImage, { isHidden: imageLoading, src: imageUrl, alt: imageAlt, onError: handleError, onLoad: handleLoad }), renderTags(), hasActionIcon && !imageLoading && (_jsx(ActionIconContainer, { size: size, children: _jsx(ActionIcon, { size: "small", onClick: onClickActionIcon }) }))] }));
    };
    return (_jsx(StyledImageContainer, { size: size, borderRadius: borderRadius, loading: loading, ...props, children: imageContent() }));
});
export default ImageCar;
//# sourceMappingURL=ImageCar.js.map